module.exports = __webpack_public_path__ + "static/key-goat-a106c2d4c6c9710df13c20bcc11e4603.webp";